import UserEventList from './UserEventList';

export default UserEventList;
